import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box, Typography, Paper, Divider, alpha, Stack } from '@mui/material';
import Swal from 'sweetalert2';
import { useTheme } from '@mui/material/styles';

import { Modal, Row, Col } from '../../components/BootstrapToMUI';

export default function ViewCoinModal(props) {
  const theme = useTheme();
  const { data, ...rest } = props;

  const coinInfo = data?.coinInfo;
  const symbol = data?.currency?.symbol;

  // Filter out tubes with tubeValue > 0 for display
  const activeTubes = coinInfo?.filter((tube) => tube.tubeValue > 0) || [];

  // Calculate total sum
  const totalSum = activeTubes.reduce((sum, tube) => {
    return sum + tube.tubeValue * tube.coinCount;
  }, 0);

  return (
    <Modal className="modal-w" {...rest} centered size="sm">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Coin Information - {data?.currency?.code}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Box sx={{ px: 2, py: 1 }}>
          {activeTubes.length > 0 ? (
            <Box>
              {/* Coin Tubes List */}
              <Stack spacing={1.5} sx={{ mb: 2 }}>
                {activeTubes.map((tube, i) => (
                  <Paper
                    key={i}
                    elevation={0}
                    sx={{
                      p: 1.5,
                      backgroundColor: alpha(theme.palette.info.main, 0.03),
                      borderRadius: 1.5,
                      border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
                    }}
                  >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.875rem' }}>
                        Value: {symbol}{tube.tubeValue.toFixed(2)}
                      </Typography>
                      <Typography variant="body2" sx={{ fontSize: '0.875rem', color: theme.palette.text.secondary }}>
                        Count: {tube.coinCount}
                      </Typography>
                    </Box>
                  </Paper>
                ))}
              </Stack>

              {/* Total Sum */}
              <Divider sx={{ my: 2 }} />
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  backgroundColor: alpha(theme.palette.success.main, 0.05),
                  borderRadius: 1.5,
                  border: `1.5px solid ${alpha(theme.palette.success.main, 0.2)}`,
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="body1" sx={{ fontWeight: 700, fontSize: '0.95rem' }}>
                    Total Sum:
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 700,
                      fontSize: '0.95rem',
                      color: theme.palette.success.dark,
                    }}
                  >
                    {symbol}{totalSum.toFixed(2)}
                  </Typography>
                </Box>
              </Paper>
            </Box>
          ) : (
            <Box sx={{ py: 3, textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary">
                No coin information available
              </Typography>
            </Box>
          )}
        </Box>
      </Modal.Body>
    </Modal>
  );
}
